import { DiscountType, type OrderLineDiscountRecord } from '@navio/nsdk';

const isFrozen = (frozenAt?: string | null) => frozenAt != null;

export const canEditDiscount = (discount: OrderLineDiscountRecord, orderLineFrozenAt?: string | null) =>
  discount.type === DiscountType.AD_HOC && !isFrozen(discount.frozenAt) && !isFrozen(orderLineFrozenAt);

export const canDeleteDiscount = (discount: OrderLineDiscountRecord, orderLineFrozenAt?: string | null) =>
  !isFrozen(discount.frozenAt) && !isFrozen(orderLineFrozenAt);

export const canAddDiscountToLine = (orderLine: { frozenAt?: string | null }) => !isFrozen(orderLine.frozenAt);
